import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Checkbox from '@shared/ui/checkbox'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
} from '@shared/ui/form'
import Radio from '@shared/ui/radio'
import Textarea from '@shared/ui/text-area'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function DetailOrderForm () {
  const { control } = useFormContext()
  const { t } = useTranslation('order')

  const options = [
    {
      value: 1,
      name: t('replacement_options.call_to_agree'),
      description: t('replacement_options.call_to_agree_desc'),
    },
    {
      value: 2,
      name: t('replacement_options.auto_replace'),
      description: t('replacement_options.auto_replace_desc'),
    },
    {
      value: 3,
      name: t('replacement_options.app_replace'),
      description: t('replacement_options.app_replace_desc'),
    },
    {
      value: 4,
      name: t('replacement_options.remove_items'),
      description: t('replacement_options.remove_items_desc'),
    },
  ]

  return (
    <Wrapper className={styles.root__wrapper}>
      <div className={styles.root}>
        <h3 className={styles.root__title}>{t('detail_order')}</h3>
        <FormField
          control={control}
          name="replacementOption"
          render={({ field }) => (
            <div className={styles.radio}>
              {options.map(({ value, name, description }) => (
                <FormItem key={value} className={styles.radio__item}>
                  <FormControl>
                    <Radio
                      value={value}
                      checked={field.value === value}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                      ref={field.ref}
                    />
                  </FormControl>
                  <div className={styles.radio__text}>
                    <span className={styles.radio__title}>{name}</span>
                    <span className={styles.radio__description}>
                      {description}
                    </span>
                  </div>
                </FormItem>
              ))}
            </div>
          )}
        />
        <FormField
          control={control}
          name="commentBuilder"
          render={({ field }) => (
            <>
              <FormItem>
                <FormControl>
                  <Textarea
                    {...field}
                    placeholder={t('form.comment_builder_placeholder')}
                  />
                </FormControl>
                <FormDescription>
                  {t('form.comment_builder_description')}
                  <br />
                  {t('form.comment_builder_price')}
                </FormDescription>
              </FormItem>
            </>
          )}
        />
        <FormField
          control={control}
          name={'packages'}
          render={({ field }) => (
            <FormItem className={styles.root__checkbox}>
              <FormControl>
                <Checkbox
                  label={t('form.packages_label')}
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </Wrapper>
  )
}
